// extracted by mini-css-extract-plugin
module.exports = {"allPackagesCarousel":"AllPackagesCarousel_allPackagesCarousel__jksi9","container":"AllPackagesCarousel_container__sQOpl","actionButtons":"AllPackagesCarousel_actionButtons__VIZxZ"};